import { apiCall, apiCallGeneric } from "../../components/service/api-service";

export const getDeleteApi = async (deleteUrl) => {
  return apiCall("DELETE", deleteUrl);
};

export const bulkDeleteApi = async (deleteUrl, ids) => {
  return apiCall("DELETE", deleteUrl, { id: ids });
};

export const websiteDeleteApi = async (url, payload) => {
  return apiCallGeneric("PUT", url, payload);
};